import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { communityProfileSchema } from './schemas';

export const communityProfileQueryOptions = (id: number | null) =>
  queryOptions({
    queryKey: QueryKeys.community.show.id(id ?? 0),
    queryFn: async () => {
      const { data: communityProfile } = await fetchJson(`/community/${id}`, {
        schema: apiResourceSchema(communityProfileSchema),
      });

      return communityProfile;
    },
    staleTime: 10 * 60 * 1000,
    enabled: id !== null,
  });

export const useCommunityProfile = (id: number | null) => {
  return useQuery(communityProfileQueryOptions(id));
};
